<div class="tw-flex tw-flex-row" style="height: 100%;">
    <div class="tw-w-full">
        <mat-tab-group color="primary" animationDuration="0ms" style="height: 100%;" [selectedIndex]="getTabChange" 
            [class.no-selection]="getTabChange === -1"
            (selectedTabChange)="tabPanelChange.emit($event.tab.textLabel)"
        >
            <mat-tab label="{{'FIDELITY.SETUP.CAMPAIGNS.TITLE' | translate}}"></mat-tab>
            <mat-tab label="{{'FIDELITY.SETUP.RULES.TITLE' | translate}}"></mat-tab>
            <mat-tab label="{{'FIDELITY.SETUP.PRIZES.TITLE' | translate}}"></mat-tab>
        </mat-tab-group>
    </div>
</div>
